import React, { useState, useEffect, useRef } from "react";
import "./css/styles.css";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";

import { Card, Button, TextField, FormControl, Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import ProgressBar from "./ProgressBar";

import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  where,
  orderBy,
  getDoc,
} from "firebase/firestore";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUploader from "react-firebase-file-uploader";
import { db, storage, app } from "../firebase";
import { muiBbtn } from "./style";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { set } from "date-fns";
export default function ViewServices() {
  const [categories, setCategories] = useState([]);
  const [Title, setTitle] = useState("");
  const [Price, setPrice] = useState(""); ///To check if data if loaded or not from collection.
  const [Category, setCategory] = useState("");
  const [Description, setDescription] = useState("");
  const [Variant, setVariant] = useState([]);
  const [UploadImage, setUploadImage] = useState("");
  const [UploadProgress, setUploadProgress] = useState(0);
  const [isProcessing, setisProcessing] = useState(false);
  const [newVariant, setnewVariant] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [Colors, setColors] = useState([]);
  const [filenames, setfilenames] = useState([]);
  const [downloadURLs, setdownloadURLs] = useState([]);
  const [isUploading, setisUploading] = useState(false);
  const [files, setFiles] = useState([]);
  const [Stock, setStock] = useState("");
  const [type, setType] = useState("");
  const [country, setCountry] = useState("");
  const fileUploader = useRef();

  const { DocId } = useParams();
  useEffect(() => {
    const getData = async () => {
      if (DocId) {
        getDoc(doc(db, "services", DocId)).then((res) => {
          getDoc(doc(db, "category", res.data().category)).then((cat) => {
            setCategory(cat.data().name);
          });
          setTitle(res.data().title);
          setPrice(res.data().price);
          setDescription(res.data().description);
          setVariant(res.data().variants);
          setdownloadURLs(res.data().images);
          setThumbnail(res.data().thumbnail);
          setColors(res.data().colors);
          setStock(res.data().stock);
          setType(res.data().type);
          setCountry(res.data().country);
        });
      }
    };
    getData();
  }, []);
  const handleDelete = (v) => {
    setVariant(Variant.filter((Variant) => Variant !== v));
  };

  const saveService = (url = null) => {
    var data = {
      title: Title,
      category: Category,
      description: Description,
      price: Price,
      variants: Variant,
      thumbnail: thumbnail,
      images: downloadURLs,
    };
    if (url != null) {
      data.thumbnail = url;
    }

    if (DocId) {
      updateDoc(doc(db, "services", DocId), data)
        .then(() => {
          setisProcessing(false);
          toast.success("Service Updated");
          // formReset();
          setUploadProgress(0);
          setFiles([]);
          document.getElementById("uploadThumbnail").value = "";
          document.getElementById("uploadImages").value = "";
        })
        .catch((error) => {
          setisProcessing(false);

          toast.error("Error! unable to Update Service");
          console.log(error);
        });
    } else {
      const newDoc = doc(collection(db, "services"));
      data.id = newDoc.id;
      data.created_on = new Date();
      setDoc(newDoc, data)
        .then(() => {
          setisProcessing(false);

          toast.success("Service Added");
          formReset();
        })
        .catch((error) => {
          setisProcessing(false);
          toast.error("Error! unable to Add Service");
          console.log(error);
        });
    }
  };

  const handleUploadStart = () => {
    setisUploading(true);
    setUploadProgress(0);
  };

  const handleProgress = (progress) => {
    setUploadProgress(progress);
  };

  const handleUploadError = (error) => {
    setisUploading(false);
    console.error(error);
  };

  const handleUploadSuccess = async (filename) => {
    const downloadURL = await app
      .storage()
      .ref("Service_images")
      .child(filename)
      .getDownloadURL();

    setfilenames((old) => [...old, filename]);
    setdownloadURLs((old) => [...old, downloadURL]);
    setUploadProgress(0);
    setisUploading(false);
  };
  const handleUploadSuccessThumbnail = async (filename) => {
    const downloadURL = await app
      .storage()
      .ref("Service_images")
      .child(filename)
      .getDownloadURL();

    setThumbnail((old) => [...old, downloadURL]);
    setUploadProgress(0);
    setisUploading(false);
  };
  // const customOnChangeHandler = (event) => {
  //   // const {
  //   //   target: { files },
  //   // } = event;
  //   // setfiles((files)=>[...files,event.target.files])
  //   // const filesToStore = [];
  //   console.log("hyy");
  //   console.log(event);
  //   // event.target.files.forEach((file) => filesToStore.push(file));
  //   const filesToStore = Array.from(event.target.files);
  //   setFiles(filesToStore);
  // };

  // const startUploadManually = () => {
  //   files.forEach((file) => {
  //     fileUploader.current.startUpload(file);
  //   });
  // };

  const addService = () => {
    if (!Title || !Description || !Price || !Category) {
      toast.error("Kindly Fill All Input Fields");
      return;
    }

    setisProcessing(true);
    // startUploadManually();
    if (UploadImage) {
      const storageRef = ref(
        storage,
        `/Service_images/${Title + Math.floor(Math.random() * 1000) + 1}`
      );

      const uploadTask = uploadBytesResumable(storageRef, UploadImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setUploadProgress(percent);
        },
        (err) => console.log(err),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setUploadImage(null);
            saveService(url);
          });
        }
      );
    } else {
      saveService();
    }
  };
  const formReset = () => {
    setTitle("");
    setDescription("");
    setCategory("");
    setPrice("");
    setVariant([]);
    setdownloadURLs([]);
    setUploadProgress(0);
    setFiles([]);
    document.getElementById("uploadThumbnail").value = "";
    document.getElementById("uploadImages").value = "";
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        backgroundColor: "#212C62",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 60, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>{Title}</b>
            </h1>
          </div>
        </div>

        <div className="d-flex border-bottom row justify-content-between align-items-start">
          <div className="col-6 ">
            <img width="auto" style={{ maxHeight: "400px" }} src={thumbnail} />
            <div className="row my-3">
              {downloadURLs?.map((image, key) => {
                return (
                  <>
                    <div role="button" key={key} className="col-4 text-center">
                      <div
                        className={
                          thumbnail === image ? "selected-image" : null
                        }
                      >
                        <img
                          width="auto"
                          style={{ maxHeight: "70px" }}
                          src={image}
                          onClick={() => setThumbnail(image)}
                        />
                        {thumbnail === image ? (
                          <div class="image-overlay"></div>
                        ) : null}
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Price :</b> {Price}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Category :</b> {Category}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Country :</b> {country}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Type :</b> {type}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Description :</b> {Description}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Stock :</b> {Stock}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                {Variant?.map((variant, key) => {
                  return (
                    <>
                      {key !== 0 ? <br /> : null}
                      <b>{variant.variantType} : </b>
                      {variant.values?.map((val) => {
                        return (
                          <Chip
                            label={val}
                            className="me-2 mb-2"
                            variant="outlined"
                          />
                        );
                      })}
                    </>
                  );
                })}
              </span>
            </div>
            <div className="d-flex justify-content-between py-2 border-bottom">
              <span className="col-12">
                <b>Colors :</b>{" "}
                {Colors?.map((Color, key) => {
                  return (
                    <Chip
                      key={key}
                      label={"#" + Color}
                      className="me-2 mb-2"
                      Variant="outlined"
                      style={{ backgroundColor: "#" + Color, color: "white" }}
                    />
                  );
                })}
              </span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
